import { TopicName } from './types/MessageTopics';
import { CommandTopic, COMMAND_TOPICS } from './types/CommandTopics';

export function isCommandTopic(topic: TopicName): topic is CommandTopic {
  return COMMAND_TOPICS.includes(topic as CommandTopic);
}
